import React, { useState, useContext, useEffect } from "react";
import { Typography, Button, Box, List, ListItem, Tooltip } from "@mui/material";
import CommonAccordion from "../../custom-components/CommonAccordion";
import { useLocation, useNavigate } from "react-router-dom";
import ThumbDownIcon from "@mui/icons-material/ThumbDown";
import ThumbUpIcon from "@mui/icons-material/ThumbUp";
import ThumbUpOutlinedIcon from "@mui/icons-material/ThumbUpOutlined";
import ThumbDownOutlinedIcon from "@mui/icons-material/ThumbDownOutlined";
import ContentCopyOutlinedIcon from "@mui/icons-material/ContentCopyOutlined";
import { featureFiles } from "../../../services/webServices";
import { LoadingModalContext } from "../../main-pages/ServicePage";
import { flattenArray, flattenObject } from "../../../utils/dataFlatteners";
import CommonCopy from "../../custom-components/CommonCopy";
import PromptsPopUp from "./PromptsPopUp";

const TestCaseUI = (props) => {
    const location = useLocation();
    const navigate = useNavigate();
    const nextButton = !!props.testcaseNextButton ? [props.testcaseNextButton] : [];
    const downloadButton = !!props.javaSeliniumDownloadButton ? [props.javaSeliniumDownloadButton] : [];
    const rpfDownloadButton = !!props.robotFrameworkDownloadButton ? [props.robotFrameworkDownloadButton] : [];
    const [downloadOpen, setDownloadOpen] = useState(false);
    const [activeThumb, setActiveThumb] = useState(null);
    const [isCopied, setIsCopied] = useState(false);
    const setLoading = useContext(LoadingModalContext);
    const [isDownloadDisabled, setIsDownloadDisabled] = useState(true);
    const [showPopup, setShowPopup] = useState(false);
    const hasTestCases = Object.entries(props.testCaseData || {}).length > 0;
    const defaultTestCasesExpanded =
        hasTestCases && !((!!location.state.featureFileData && location.state.featureFileData !== "") || (!!location.state.keywordDesignData && location.state.keywordDesignData !== "")) && !props.PageSource;

    const testCaseData = props.testCaseData;

    const handleDownloadClick = () => {
        setDownloadOpen(true);
    };

    const handleGenerateTestCases = async () => {
        setLoading(true);
        try {
            // Your API call to generate feature files
            const generatedFeatureFileResponse = await featureFiles(props.testCaseData);
            // Make sure to define testCasesData
            const generatedFeatureFile = generatedFeatureFileResponse.data;
            navigate(location.pathname, { state: { ...location.state, featureFileData: generatedFeatureFile }, replace: true })
        } catch (error) {
            console.error("Error generating feature files:", error);
        } finally {
            setLoading(false);
        }
    };
    const handleCloseDownload = () => {
        setDownloadOpen(false);
    }
    const handleCopyClick = () => {
        setIsCopied(true);
        setTimeout(() => setIsCopied(false), 2000);
    };

    const handleThumbClick = (thumbType) => {
        setActiveThumb((prev) => (prev === thumbType ? null : thumbType));
    };

    const formatTestPlan = (testPlanData) => {
        const formattedTestPlan = {};
        Object.entries(testPlanData).map(([key, value]) => {
            // console.log(typeof value);
            // console.log(value)
            if (Array.isArray(value)) {
                return (formattedTestPlan[key] = flattenArray(value));
            }
            if (!!value && typeof value === "object") {
                return (formattedTestPlan[key] = flattenObject(value));
            }
            return (formattedTestPlan[key] = value);
        });
        // console.log(formattedTestPlan)
        return formattedTestPlan;
    };
    const formatValue = (value) => {
        //console.log("Value", value);
        if (Array.isArray(value)) {
            return flattenArray(value);
        }
        if (value && typeof value === 'object') {
            return (flattenObject(value));
        }
        return value;
    };


    const handlePromptsPopup = () => {
        setShowPopup(true);
    }
    const handleClosePopup = () => {
        setShowPopup(false);
    }


    return (
        <Box data-testcase-component>
            <CommonAccordion
                summary={"Test Case Imported"}
                details={
                    <Box sx={{ backgroundColor: '#fff', borderRadius: 1, p: 2, marginTop: '-15px' }}>

                        <Typography
                            variant="subtitle1"
                            gutterBottom
                            sx={{

                                color: '#545F71'
                            }}
                        >
                            Test Case ID
                        </Typography>

                        <Typography variant="body1" gutterBottom>
                            {formatValue(testCaseData["Test Case ID"] || "")}

                        </Typography>

                        <Typography variant="subtitle1" gutterBottom>
                            <Typography
                                variant="subtitle1"
                                gutterBottom
                                sx={{

                                    color: '#545F71'
                                }}
                            >
                                Test Case Title</Typography>
                        </Typography>

                        <Typography variant="body1" gutterBottom>
                            {formatValue(testCaseData["Test Case Title"] || "")}
                        </Typography>

                        <Typography variant="subtitle1" gutterBottom>
                            <Typography
                                variant="subtitle1"
                                gutterBottom
                                sx={{

                                    color: '#545F71'
                                }}
                            >
                                Module Name</Typography>
                        </Typography>
                        <Typography variant="body1" gutterBottom>{formatValue(testCaseData["Module Name"] || "")}</Typography>
                        <Typography variant="subtitle1" gutterBottom>
                            <Typography
                                variant="subtitle1"
                                gutterBottom
                                sx={{

                                    color: '#545F71'
                                }}
                            >
                                Test Objective</Typography>
                        </Typography>
                        <Typography
                            variant="body1"
                            dangerouslySetInnerHTML={{
                                __html: formatValue(testCaseData["Test Objective"] || "").toString().replace(/\n/g, "<br>"),
                            }}
                        />


                        <Typography variant="subtitle1" gutterBottom>
                            <Typography
                                variant="subtitle1"
                                gutterBottom
                                sx={{

                                    color: '#545F71'
                                }}
                            >
                                Pre-conditions</Typography>
                        </Typography>
                        <Typography
                            variant="body1"
                            dangerouslySetInnerHTML={{
                                __html: formatValue(testCaseData["Preconditions"] || "").toString().replace(/\n/g, "<br>"),
                            }}
                        />

                        <Typography variant="subtitle1" gutterBottom>
                            <Typography
                                variant="subtitle1"
                                gutterBottom
                                sx={{

                                    color: '#545F71'
                                }}
                            >
                                Test Steps </Typography>
                        </Typography>
                        <Typography
                            variant="body1"
                            dangerouslySetInnerHTML={{
                                __html: formatValue(testCaseData["Test Steps"] || "").toString().replace(/\n/g, "<br>"),
                            }}
                        />

                        <Typography variant="subtitle1" gutterBottom>
                            <Typography
                                variant="subtitle1"
                                gutterBottom
                                sx={{

                                    color: '#545F71'
                                }}
                            >
                                Expected Result</Typography>
                        </Typography>
                        <Typography
                            variant="body1"
                            dangerouslySetInnerHTML={{
                                __html: formatValue(testCaseData["Expected Result"] || "").toString().replace(/\n/g, "<br>"),
                            }}
                        />
                        <Typography variant="subtitle1" gutterBottom>
                            <Typography
                                variant="subtitle1"
                                gutterBottom
                                sx={{

                                    color: '#545F71'
                                }}
                            >
                                Post-Conditions</Typography>
                        </Typography>
                        {/* <Typography variant="body1" gutterBottom>{testCaseData["Test Steps"]}</Typography> */}
                        <Typography
                            variant="body1"
                            dangerouslySetInnerHTML={{
                                __html: formatValue(testCaseData["Post-conditions"] ||"").toString().replace(/\n/g, "<br>"),
                            }}
                        />

                        <Typography variant="subtitle1" gutterBottom>
                            <Typography
                                variant="subtitle1"
                                gutterBottom
                                sx={{

                                    color: '#545F71'
                                }}
                            >
                                Test Data</Typography>
                        </Typography>
                        <Typography
                            variant="body1"
                            dangerouslySetInnerHTML={{
                                __html: formatValue(testCaseData["Test Data (if applicable)"] || "").toString().replace(/\n/g, "<br>"),
                            }}
                        />
                        <Typography variant="subtitle1" gutterBottom>
                            <Typography
                                variant="subtitle1"
                                gutterBottom
                                sx={{

                                    color: '#545F71'
                                }}
                            >
                                Priority</Typography>
                        </Typography>
                        <Typography
                            variant="body1" gutterBottom>{formatValue(testCaseData["Priority"] || "")}</Typography>

                        <Typography variant="subtitle1" gutterBottom>
                            <Typography
                                variant="subtitle1"
                                gutterBottom
                                sx={{

                                    color: '#545F71'
                                }}
                            >
                                Type</Typography>
                        </Typography>
                        <Typography
                            variant="body1">
                            {formatValue(testCaseData["Type"])}
                        </Typography>
                        <Typography variant="subtitle1" gutterBottom>
                            <Typography
                                variant="subtitle1"
                                gutterBottom
                                sx={{

                                    color: '#545F71'
                                }}
                            >
                                Remarks</Typography>
                        </Typography>
                        <Typography
                            variant="body1"
                            dangerouslySetInnerHTML={{
                                __html: formatValue(testCaseData["Remarks"] || "").toString().replace(/\n/g, "<br>"),
                            }}
                        />

                        <Box sx={{ display: "flex", alignItems: "center", gap: 1, mb: 2, mt: 2 }}>
                            <Tooltip title="Like" arrow>
                                <Box
                                    onClick={() => handleThumbClick("like")}
                                    sx={{
                                        cursor: "pointer",
                                        marginRight: 2,
                                        "&:hover": { color: "#49A3FF" },
                                    }}
                                >
                                    {activeThumb === "like" ? (
                                        <ThumbUpIcon sx={{ fontSize: "24px" }} />
                                    ) : (
                                        <ThumbUpOutlinedIcon sx={{ fontSize: "24px" }} />
                                    )}
                                </Box>
                            </Tooltip>

                            <Tooltip title="Dislike" arrow>
                                <Box
                                    onClick={() => handleThumbClick("dislike")}
                                    sx={{
                                        cursor: "pointer",
                                        marginRight: 2,
                                        "&:hover": { color: "#FF4842" },
                                    }}
                                >
                                    {activeThumb === "dislike" ? (
                                        <ThumbDownIcon sx={{ fontSize: "24px" }} />
                                    ) : (
                                        <ThumbDownOutlinedIcon sx={{ fontSize: "24px" }} />
                                    )}
                                </Box>
                            </Tooltip>
                            <CommonCopy contentToCopy={testCaseData} />


                        </Box>
                    </Box>
                }
                buttons={[
                    // ...downloadButton,
                    ...rpfDownloadButton,
                    ...nextButton,
                  
                ]}

                fullScreenMode={true}
                type={"output"}
                defaultExpanded={defaultTestCasesExpanded}


            />

            {/* <CommonDownload open={downloadOpen} onClose={handleCloseDownload}
                wordData={[
                    {
                        type: "subParagraphs",
                        data: testCaseData,
                    },
                ]}
                serviceName={"Test Case Details"}
                serviceResponse={formatTestPlan(testCaseData)}
                documents={['xls', 'csv']}
            /> */}
            <PromptsPopUp open={showPopup} handleClose={handleClosePopup} />
        </Box>
    );
};

export default TestCaseUI;
